module.exports = __webpack_public_path__ + "img/step6.8eb8cb59.png";